<template>
	<div class="col-12 mt-2 mb-2">
		<div class="form-group">
			<div class="text-center">
				{{ validation_message }}<br />
				<a v-if="cgu_cgv_link" :href="cgu_cgv_link" target="_blank" class="btn-link btn">{{ $t('monte.cgu_cgv') }}</a> <a v-if="privacy_policy_link" :href="privacy_policy_link" target="_blank" class="btn-link btn">{{ $t('monte.privacy_policy') }}</a>

			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
import Contract from "@/mixins/Contract.js"

export default {
	name: "PrivacyPolicyAck",
	mixins: [Contract],
	data () {
		return {
			validation_message: '',
			cgu_cgv_link: null,
			privacy_policy_link: null,
		}
	},
	created() {
		this.preinit_component()
	},
	methods: {
		preinit_component() {
			this.contractPrivacyPolicy()
				.then(res => {
					if(res) {
						this.validation_message = res.privacy_policy_content
						this.cgu_cgv_link = res.cgv_link
						this.privacy_policy_link = res.privacy_link
					}
				})
		}
	}
}
</script>
